import {
  Input,
  InputGroup,
  InputLeftAddon,
  Stack,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import { SellYourFormValues } from '@/app/sell-my-car/service';

import Styles from '../SellYourCarForm.module.scss';

export const ExpectedPriceInput = ({
  control,
  errors,
}: {
  control: Control<SellYourFormValues>;
  errors: FieldErrors<SellYourFormValues>;
}) => (
  <Stack spacing={6} mb={{ sm: '40px' }}>
    <Controller
      name="vehicle_expected_price"
      control={control}
      rules={{
        required: 'We would love to know how much you would like for your car',
        validate: (value) => {
          if (!/^\d+$/.test(value)) {
            return 'Please only capture numbers with non decimals';
          }

          const numValue = Number(value);

          if (numValue <= 0) {
            return 'Price must be greater than 0';
          }

          if (value.length > 8) {
            return 'It seems you have captured too many digits';
          }

          return true;
        },
      }}
      render={({ field }) => (
        <InputGroup>
          <InputLeftAddon className={Styles.formInput}>R</InputLeftAddon>
          <Input
            {...field}
            type="number"
            className={Styles.formInput}
            placeholder="Enter amount"
            min="1"
            max="99999999"
          />
        </InputGroup>
      )}
    />
    {errors.vehicle_expected_price && (
      <Text color="red.500" fontSize="sm">
        {errors.vehicle_expected_price.message}
      </Text>
    )}
  </Stack>
);
